import React from 'react';
import { Link } from 'react-router-dom';

import BaseDetailScreen from '../BaseDetailScreen';

import './styles.css';

const Component = ({ accountNumber }) => (
  <BaseDetailScreen
    backTo={`/account/${accountNumber}`}
    backLabel="Manage Account"
    pageHeading="Restricted Account"
  >
    <div styleName="errorContainer">
      Your account is currently restricted and cannot transfer funds.
      Please check the&nbsp;<Link to={`/account/${accountNumber}`}>Account Management</Link>
      &nbsp;page for additional information.
    </div>
  </BaseDetailScreen>
);

Component.displayName = 'TransferError';

export default Component;



// WEBPACK FOOTER //
// ./src/components/TransferFunds/TransferError.js